import { BUSINESS_UNIT_CODES, currentBusinessUnit } from 'lib/businessUnit';

export const isDevelopmentEnv = (): boolean => process.env.NODE_ENV === 'development';
export const isStagingEnv = (): boolean => process.env.BNW_ENV === 'staging';
export const isProductionEnv = (): boolean => process.env.NODE_ENV === 'production'
  && process.env.BNW_ENV === 'production';
export const isTest = (): boolean => process.env.NODE_ENV === 'test';

export const onlyUSTraffic = (): boolean => currentBusinessUnit().code === BUSINESS_UNIT_CODES.US;
export const onlyUKTraffic = (): boolean => currentBusinessUnit().code === BUSINESS_UNIT_CODES.UK;

export const shouldMaskPhoneNumber = (): boolean => onlyUSTraffic();
export const shouldDisplayProductName = (): boolean => onlyUSTraffic();
export const shouldShowClaimContactDetails = (): boolean => onlyUKTraffic();
export const showCertificateOfInsurance = (): boolean => onlyUSTraffic();
export const shouldShowUKTilesList = (): boolean => onlyUKTraffic();

export const shouldShowVanPhaseOne = (): boolean => false;

export const isAndroid = (): boolean => /Android/i.test(navigator.userAgent);

export const isApple = (): boolean => /iPhone/i.test(navigator.userAgent);

export const shouldShowGoogleWalletButton = (): boolean => isAndroid();

export const shouldShowAppleWalletButton = (): boolean => isApple();

export const shouldShowWalletButton = (): boolean => shouldShowAppleWalletButton() || shouldShowGoogleWalletButton();

export const shouldSignInWithMfa = (): boolean => isStagingEnv() || isProductionEnv();

export default {
  isDevelopmentEnv,
  isStagingEnv,
  isProductionEnv,
  isTest,
  onlyUKTraffic,
  shouldMaskPhoneNumber,
  shouldDisplayProductName,
  onlyUSTraffic,
  showCertificateOfInsurance,
  shouldShowClaimContactDetails,
  shouldShowUKTilesList,
  shouldShowVanPhaseOne,
  isAndroid,
  shouldShowGoogleWalletButton,
  isApple,
  shouldShowAppleWalletButton,
  shouldShowWalletButton,
  shouldSignInWithMfa,
};
